
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, Search } from "lucide-react";

interface ClientesSearchProps {
  search: string;
  onSearchChange: (value: string) => void;
}

const ClientesSearch = ({ search, onSearchChange }: ClientesSearchProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Buscar clientes..."
          className="pl-8 w-full"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <Link to="/clientes/novo">
        <Button className="w-full sm:w-auto bg-energy-blue text-white hover:bg-energy-blue-dark">
          <Plus className="mr-2 h-4 w-4" />
          Novo Cliente
        </Button>
      </Link>
    </div>
  );
};

export default ClientesSearch;
